import {Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    standalone: false,
    selector: 'core-block-stories-index-banner',
    templateUrl: './block-stories-index-banner.component.html',
})

export class BlockStoriesIndexBannerComponent extends BlockAbstractComponent implements OnInit {

}
